module.exports = __webpack_public_path__ + "img/1.c33a3f3b.jpg";